import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase, UserService } from 'vnpost-shared';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { UnitService } from '../../../core/services/unit-service';
import { SaleAssociateService } from '../../services/sale-associate.service';

@Component({
  selector: 'app-edit-sale-associate',
  templateUrl: './edit-sale-associate.component.html',
  styleUrls: ['./edit-sale-associate.component.css']
})
export class EditSaleAssociateComponent extends SecondPageEditBase implements OnInit {

  listGender: { label: string; value: number }[] = [{label: "Nam", value: 1}, {label: "Nữ", value: 0}];
  listUnit: { label: string; value: string }[] = [];
  listStatus: { label: string; value: number }[] = [
    { label: 'Đang hoạt động', value: 1 },
    { label: 'Dừng hoạt động', value: 0 },
  ];
  listEthnic: { label: string; value: string }[] = [
    { label: 'Kinh', value: '1' },
    { label: 'Khác', value: '2' },
  ];
  isDisable: any;

  constructor(
    protected _saleAssociateService: SaleAssociateService,
    protected _injector: Injector,
    private _unitService: UnitService,
  ) {
    super(_saleAssociateService, _injector);
    this.formGroup = new UntypedFormGroup({
      salesAssociateCode: new UntypedFormControl([Validators.required]),
      email: new UntypedFormControl('', [Validators.email]),
      displayName: new UntypedFormControl('', [Validators.required]),
      location: new UntypedFormControl(''),
      gender: new UntypedFormControl('', [Validators.required]),
      userName: new UntypedFormControl([Validators.required]),
      dateOfBirth: new UntypedFormControl('', [Validators.required]),
      phoneNumber: new UntypedFormControl('', [Validators.required, Validators.pattern(/^0\d{8,11}$/)]),
      citizenId: new UntypedFormControl('', [Validators.pattern(/^\d{9,12}$/)]),
      socialInsuranceCode: new UntypedFormControl(''),
      address: new UntypedFormControl(''),
      unitCode: new UntypedFormControl('', [Validators.required]),
      notes: new UntypedFormControl(''),
      status: new UntypedFormControl(''),
    });
  }

  ngOnInit() {
  }

  getListUnit() {
    this._unitService.getTreeUnitByUnitCode(this.currentUser?.unitCode).then((rs) => {
      if (rs.success) {
        this.listUnit = rs?.data
          ?.map((r) => ({
            label: `- ${r.unitName} (${r.unitCode})`,
            value: r.unitCode,
          }));
      } else {
        this.listUnit = [];
      }
    });
  }

  onShowPopup(model: any) {
    if (this.listUnit.length == 0) {
      this.getListUnit();
    }
    this.isDisable = model.isDisable;
    this.validationSummary.resetErrorMessages();
    this.resetForm();

    if (model.id > 0) {
      this._saleAssociateService.getSalesAssociateDetail(model.id).then(async rs => {
        this.itemDetail = rs.data;
        if (this.itemDetail.dateOfBirth) {
          this.itemDetail.dateOfBirth = new Date(this.itemDetail.dateOfBirth);
        }
      }, error => {
        if (error?.error?.message) 
          this._notifierService.showError(error?.error?.message);
        else this._notifierService.showWarning(this._translateService.instant('MESSAGE.NOT_FOUND_ERROR'));
      });
    }
  }

  async save() {
    this.submitting = true;

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }

    this.onBeforeSave();

    this.onUpdate();
  }

  onUpdate() {
    this._saleAssociateService.update(this.itemDetail['id'].toString(), this.itemDetail)
      .then(response => {
        this.closePopupMethod(true);
        this._notifierService.showUpdateDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      }, error => {
        if (error?.error?.message) 
          this._notifierService.showError(error?.error?.message);
        else this._notifierService.showUpdateDataFailed();
        this.submitting = false;
      });
  }
}
